export default function SvgCamera3() {
  return (
    <>
    <svg
     xmlns="http://www.w3.org/2000/svg"
     width="35px"
     fill="none"
     viewBox="0 0 24 24"
     >
     <path
      stroke="blue"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 9a2 2 0 012-2h1.5a2 2 0 001.6-.8l1.05-1.4a2 2 0 011.6-.8h2.5a2 2 0 011.6.8l1.05 1.4a2 2 0 001.6.8H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
    ></path>
    <circle
      cx="12"
      cy="13"
      r="4"
      stroke="blue"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    ></circle>
   </svg>
  </>
  );
}
